<template>
    <div>
    <div class="flex flex-row">
        <div class="flex flex-row align-items-center mb-2 mr-4">
            <div class="flex flex-row w-10rem">
                <div>length</div>
                <div class="ml-1 text-gray-500 cursor-pointer">
                    <i class="pi pi-question-circle"
                       v-tooltip.bottom="'Период вычисления средней линии движения цены. Чем больше число, тем плавнее линия.'"></i></div>
            </div>
            <InputText type="text" v-model="value.length" class="w-3rem p-1 mb-1" />
        </div>
        <div class="flex flex-row align-items-center mb-2">
            <div class="flex flex-row w-10rem">
                <div>trLength</div>
                <div class="ml-1 text-gray-500 cursor-pointer">
                    <i class="pi pi-question-circle"
                       v-tooltip.bottom="'Период вычисления среднего истинного диапазона (true range) цены. Как правило не требует изменений.'"></i></div>
            </div>
            <InputText type="text" v-model="value.trLength" class="w-3rem p-1 mb-1" />
        </div>
    </div>

    <div class="flex flex-row">
        <div class="flex flex-row align-items-center mb-2 mr-4">
            <div class="flex flex-row w-10rem">
                <div>factorHighBorder</div>
                <div class="ml-1 text-gray-500 cursor-pointer">
                    <i class="pi pi-question-circle"
                       v-tooltip.bottom="'Множитель расстояния верхней границы полосы. Чем больше число, тем дальше верхняя граница полосы будет от центра, от средней линии движения цены.'"></i></div>
            </div>
            <InputText type="text" v-model="value.factorHighBorder" class="w-3rem p-1 mb-1" />
        </div>
        <div class="flex flex-row align-items-center mb-2">
            <div class="flex flex-row w-10rem">
                <div>factorLowBorder</div>
                <div class="ml-1 text-gray-500 cursor-pointer">
                    <i class="pi pi-question-circle"
                       v-tooltip.bottom="'Множитель расстояния нижней границы полосы. Чем больше число, тем дальше нижняя граница полосы будет от центра, от средней линии движения цены.'"></i></div>
            </div>
            <InputText type="text" v-model="value.factorLowBorder" class="w-3rem p-1 mb-1" />
        </div>
    </div>
    </div>
</template>
<script>
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";

export default {
    components: {InputText, Dropdown},
    props:{
        value: Object,
    },
    data(){
        return {

        }
    },
}
</script>
